import React from 'react';
import { Chip } from '@mui/material';

/**
 * Priority color mapping
 */
const getPriorityColor = (priority: string): string => {
  switch (priority?.toLowerCase()) {
    case 'urgent':
      return '#ef4444';
    case 'high':
      return '#f59e0b';
    case 'standard':
      return '#10b981';
    case 'low':
      return '#6b7280';
    default:
      return '#6b7280';
  }
};

/**
 * Priority chip template
 */
export const PriorityChipTemplate: React.FC<{ priority?: string }> = ({ priority }) => (
  <Chip
    label={priority || 'Standard'}
    size="small"
    sx={{
      backgroundColor: getPriorityColor(priority || ''),
      color: 'white',
      fontWeight: 500,
    }}
  />
);

export default PriorityChipTemplate;
